import React, { useContext, useState } from 'react';
import * as styledComponents from './styles';
import { Container, Row } from 'react-bootstrap';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { CartContext } from 'contexts/CartContext';
import Modal from 'react-modal';
import { useAlert } from 'react-alert'

const stripePromise = loadStripe('pk_live_51BKSnsBIj9eRXne66FpgTBQqtILHBlnNpEitBkxx8d91Qq35VgqTkfpReL4fs5iXLq2sTiK8jgY5zT4KDqLUA6jO00qdrWZQIa');

const getModalTitle = (state) => {
  switch (state) {
    case 'sending':
      return 'PROCESSING PAYMENT';
    case 'success':
      return 'CONGRATULTIONS ON YOUR PURCHASE';
    case 'failure':
    default:
      return 'WE ARE SORRY';
  }
};

const getModalDescription = (state) => {
  switch (state) {
    case 'sending':
      return 'We are sending the request. It may take some seconds...';
    case 'success':
      return 'Congratulations on your purchase. We are sending you a confirmation via email with all of the details of your services purchase.';
    case 'failure':
    default:
      return 'We could not process your payment. Please contact your bank.';
  }
}

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.70)',
    zIndex: '100',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    maxWidth: '95%',
    padding: '80px 20px',
    zIndex: '101',
    background: 'linear-gradient(169.29deg, #262B2F -0.68%, #16191D 74.03%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: 'none',
  },
};


const phoneNumber = '48537435130';

const Checkout = ({ fullPaymentDone }) => {
  const { cart } = useContext(CartContext);
  const message = `I found your services in www.oracliom.com and I would like to request the following services: ${cart.map((element, idx) => `${idx + 1}. ${element.name} (${element.priceEUR}EUR) `)}`
  const alert = useAlert();

  const amountToPay = cart?.map(it => it.priceEUR).reduce((a, b) => a + b, 0) || 0;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalState, setModalState] = useState('sending');


  const showSuccesfullPayment = () => {
    setModalIsOpen(true);
    setModalState('success');
    setTimeout(() => {
      fullPaymentDone();
    }, 5000);
  }

  const showFailurePayment = () => {
    setModalIsOpen(true);
    setModalState('failure');
  }

  const showWaitingPayment = () => {
    setModalIsOpen(true);
    setModalState('sending');
  }

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  }

  const payByWhatsapp = () => {
    window.location.href = `https://wa.me/${phoneNumber}?text=${message}`;
  }

  const copyTextToClipBoard = () => {
    const el = document.createElement('textarea');
    el.value = message;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    alert.show(`Order copied to clipboard. Please paste it on the chat`, { type: 'info' });
  }

  const payByMessenger = () => {
    copyTextToClipBoard();
    setTimeout(() => {
      window.location.href = `https://m.me/oracliom`;
    }, 2000);
  }

  const payByTelegram = () => {
    copyTextToClipBoard();
    setTimeout(() => {
      window.location.href = `https://t.me/+48537435130`;
    }, 2000);
  }


  return (
    <styledComponents.CheckoutContainer>
      <Modal
        style={modalStyle}
        isOpen={modalIsOpen}
        onRequestClose={toggleModal}
      >
        <styledComponents.ModalTitle>{getModalTitle(modalState)}</styledComponents.ModalTitle>
        <styledComponents.ModalContent>{getModalDescription(modalState)}</styledComponents.ModalContent>
      </Modal>
      <Container>
        <Row>
          <styledComponents.PayButton onClick={payByWhatsapp}> REQUEST VIA WHATSAPP </styledComponents.PayButton>
          <styledComponents.PayButtonMessenger onClick={payByMessenger}> REQUEST VIA MESSENGER </styledComponents.PayButtonMessenger>
          <styledComponents.PayButtonTelegram onClick={payByTelegram}> REQUEST VIA TELEGRAM </styledComponents.PayButtonTelegram>
          <styledComponents.OrText>OR</styledComponents.OrText>
          <Elements stripe={stripePromise}>
            <CheckoutForm
              products={cart}
              amount={amountToPay}
              showWaitingPayment={showWaitingPayment}
              showSuccesfullPayment={showSuccesfullPayment}
              showFailurePayment={showFailurePayment} />
          </Elements>
        </Row>
      </Container>
    </styledComponents.CheckoutContainer>
  );
}

export default Checkout;
